import * as React from 'react'

import { Box, Spinner, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Callout from 'modules/core/components/Callout'
import ScrollableList from 'modules/core/components/ScrollableList'
import i18n from 'modules/core/lib/i18n'

import type { DocumentTemplate } from 'modules/documents/hooks/useGetDocumentTemplates'
import type { PreviewVariables } from 'modules/documents/hooks/usePreviewVariablesDocumentTemplate'
import type Variable from 'modules/documents/store/models/Variable'

import { EmptyVariablesList } from './EmptyVariablesList'
import { PreviewVariable } from './PreviewVariable'

interface Props {
  documentTemplate: DocumentTemplate
  templateVariables: Variable[]
  variableValues: PreviewVariables | undefined
  loading: boolean
}

function VariablesList({ documentTemplate, templateVariables, variableValues, loading }: Props) {
  const values = documentTemplate.values || []
  const trainingDocumentTypes = [
    'training_certificate',
    'fundae_survey',
    'fundae_certificate',
    'fundae_diploma',
  ]
  const isTrainingTemplate =
    documentTemplate.documentType && trainingDocumentTypes.includes(documentTemplate.documentType)
  return (
    <Box gap="s24">
      <Box>
        <Text.Header2>
          {i18n.t('documents.document_templates.variables_list.title_v2', {
            count: values.length,
          })}
        </Text.Header2>
        <Text.Normal>
          {i18n.t('documents.document_templates.variables_list.description')}
        </Text.Normal>
      </Box>
      {loading && (
        <Box padding="s40" width="full" alignItems="center">
          <Spinner />
        </Box>
      )}
      {!loading && (
        <Box>
          <Box
            borderRadius={{
              all: 'abs006',
            }}
            border={{
              all: {
                width: 's1',
                style: 'solid',
                color: 'grey400',
              },
            }}
          >
            {values.length == 0 && <EmptyVariablesList />}
            <ScrollableList size="full">
              {templateVariables.map((variable: Variable, index: number) => (
                <Box
                  flexDirection="column"
                  gap="s4"
                  key={index}
                  padding="s16"
                  border={{
                    bottom: {
                      width: 's1',
                      style: 'solid',
                      color: 'grey400',
                    },
                  }}
                >
                  <PreviewVariable variable={variable} variableValues={variableValues} />
                </Box>
              ))}
            </ScrollableList>
          </Box>
        </Box>
      )}
      {isTrainingTemplate && (
        <Callout
          type="info"
          hideIcon
          description={i18n.t('documents.document_templates.variables_list.callout.description')}
        />
      )}
    </Box>
  )
}

export default observer(VariablesList)
